import { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import useToggle from '../../hook/useToggle';
import { CancelIcon } from './icons';
import Button from './button';

const confirm = (props: any) => new Promise((resolve, reject) => {
    const confirmDialogDiv = document.createElement('div')
    document.body.appendChild(confirmDialogDiv)
    const root = ReactDOM.createRoot(confirmDialogDiv)

    const removeDialog = () => {
        root.unmount();
        document.body.removeChild(confirmDialogDiv);
    }

    const onHide = (e: any) => {
        removeDialog()
        e && reject(e)
    }

    const onOk = (e: any) => {
        resolve(e)
    }

    root.render(<ConfirmDialog onHide={onHide} onOk={onOk} {...props} />)
});

export default confirm;

const ConfirmDialog = (props: any) => {
    const { onHide, onClose, onOk, title, content, okText = 'OK', okBtnColor='primary', cancelText = <><CancelIcon/> Cancel</>, showCancel = true,  style, titleCenter = true, bodyCenter = true,okIcon } = props

    const { isOpen, toggle } = useToggle();

    useEffect(() => {
        toggle()
    }, [])

    const onClickHide = () => {
        toggle()
        onHide()
        onClose?.()
    }

    const onClickOk = () => {
        toggle()
        onOk(true)
        onClose?.()
    }

    const handleToggle = () => {
      toggle()
      onClose?.()
    }

    return <div className='confirm'>
         <Modal role="alertdialog" centered={true} style={{maxWidth: '600px', ...style}} isOpen={isOpen} toggle={handleToggle} backdrop="static">
            <ModalHeader cssModule={{'modal-title': titleCenter?'w-100 text-center':''}} toggle={handleToggle} tag={'h2'}>{title}</ModalHeader>
            <ModalBody className={bodyCenter?'centered-content':''}>
                <div dangerouslySetInnerHTML={{ __html: content }} />
            </ModalBody>
            <ModalFooter>
                {okText && <Button color={okBtnColor} onClick={onClickOk}>
                  {okIcon} {okText}
                </Button>
                }
                {showCancel && <Button color="secondary" onClick={onClickHide}>
                    {cancelText}
                </Button>}
            </ModalFooter>
        </Modal>
        </div>
}
